var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGy = function SvgIconGy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M12-.001c-2.122 0-4.114.551-5.844 1.517v20.966A11.94 11.94 0 0 0 12 23.999c6.627 0 12-5.373 12-12s-5.373-12-12-12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M6.192 1.498A12 12 0 0 0 4.285 2.81l9.19 9.19-9.19 9.191a12 12 0 0 1 1.907 1.312L24 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M5.178 2.127q-.55.38-1.052.817L12 12l-7.874 9.055q.503.437 1.052.817L21.946 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.285 2.81q-.4.336-.77.705L10.957 12l-7.442 8.486q.37.368.77.705l9.19-9.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.515 3.514c-4.687 4.686-4.687 12.285 0 16.97L12 12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGy;